import React from 'react';
import { Carousel } from 'primereact/carousel';

const ProductList = (props) => {
    const { top10Products } = props;

    const placeholderImage = 'https://procmart-tech.s3.ap-south-1.amazonaws.com/app-images/no_image.png';

    const responsiveOptions = [
        {
            breakpoint: '1400px',
            numVisible: 3,
            numScroll: 1
        },
        {
            breakpoint: '1299px',
            numVisible: 3,
            numScroll: 2
        },
        {
            breakpoint: '1199px',
            numVisible: 3,
            numScroll: 2
        },
        {
            breakpoint: '1000px',
            numVisible: 3,
            numScroll: 1
        },
        {
            breakpoint: '900px',
            numVisible: 2,
            numScroll: 1
        },
        {
            breakpoint: '767px',
            numVisible: 2,
            numScroll: 1
        },
        {
            breakpoint: '575px',
            numVisible: 1,
            numScroll: 1
        }
    ];

    const itemTemplate = (product) => {
        return (
            <div className="p-col">
                <div className="catalogue-request-card shadow-1 mr-1">
                    <div className="card-image hover:shadow-2">
                        <img src={product?.materialImage?.[0] || placeholderImage} className="w-full" />
                    </div>
                    <div className="catalogue-request-card-content">
                        <h6 className="mb-1 product-name">{product?.productName}</h6>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <Carousel value={top10Products} numVisible={4} numScroll={1} circular autoplayInterval={3000} itemTemplate={itemTemplate}  responsiveOptions={responsiveOptions}/>
    );
}

export default ProductList;
